// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
export const environment = {
  production: false,
  version: '1.0.1',
  environment: 'local',
  domain: null,
  www: {
    url: 'https://v12-@domain@.ticonet.it:4200'
  },
  admin: {
    url: 'https://admin-@domain@.ticonet.it:4201'
  },
  api: {
    url: 'https://api-@domain@.ticonet.it',
    // url: 'https://www-v12.azurewebsites.net',
    version: '/v1'
  },
  websocket: {
    url: 'https://api-@domain@.ticonet.it'
  },
  oidc: {
    authority: 'https://auth-@domain@.ticonet.it',
    clientId: 'v12-aspirato-www',
    // scope: 'openid profile www',
    scope: 'openid www',
    responseType: 'id_token token'
  },
  push: {
    // https://web-push-codelab.glitch.me/
    // https://codelabs.developers.google.com/codelabs/push-notifications/#0
    applicationServerKey: 'BNiQyNA0OUHsO74HYQGPO2CZji4jCEukE4-DF5QoTYi2t9BGKy1IQ5oBveywuWtlpKA_RxUbdTG-7umkUIrIbcM'
  },
  cdn: {
    // NOTE: /login/ is set in the component's array so you can use different folder, e.g. for NoAuction page
    // DEV
    url: 'https://storagev12aspirato.blob.core.windows.net'
    // url: '/assets/'
    // QA (example)
    // url: 'https://media.bmwucportal.it/public/QualityAssurance/'
    // PRODUCTION (example)
    // url: 'https://media.bmwucportal.it/public/Production/'
  }
};

